import { createEntityAdapter } from '@ngrx/entity';
import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { Country, LoadingStatus } from '@qvs/core';
import * as fromActions from './country.actions';
import { onEntityLoadingStatus } from '~/shared/helpers/loading-status-helper';

const countryEntityAdapter = createEntityAdapter<Country>();

export const initialState = countryEntityAdapter.getInitialState({
  loadingStatus: LoadingStatus.IDLE
});

export type State = typeof initialState;

export const countryFeatureKey = 'countries';

const reducer = createReducer(
  initialState,
  ...onEntityLoadingStatus<State>(fromActions.loadCountries, fromActions.loadCountriesSuccess, fromActions.loadCountriesFailure),
  on(fromActions.upsertCountries, (state, { entities }) => countryEntityAdapter.upsertMany(entities, state))
);

export const countryFeature = createFeature({
  name: countryFeatureKey,
  reducer
});

const { selectCountriesState } = countryFeature;

export const selectLoadingStatus = createSelector(selectCountriesState, (state) => state.loadingStatus);

export const selectIsLoading = createSelector(selectLoadingStatus, (loadingStatus) => loadingStatus === LoadingStatus.LOADING);

export const selectAllCountries = createSelector(selectCountriesState, countryEntityAdapter.getSelectors().selectAll);

export const selectCountriesNotInEmbargo = createSelector(selectAllCountries, (countries) =>
  countries.filter((country) => !country.embargo)
);

export const selectCountryByIso3166Alpha3 = (iso3166Alpha3Code: string) =>
  createSelector(selectAllCountries, (countries) => countries.find((country) => country.shortDescription === iso3166Alpha3Code));
